import { apiFetch } from "@/api/client";

export interface CommandResult {
  operation: string;
  exit_code: number;
  stdout: string;
  stderr: string;
  duration_ms: number;
}

export const restartRadius = () =>
  apiFetch<CommandResult>("/settings/radius/restart", {
    method: "POST",
    body: JSON.stringify({ confirm: true }),
  });

export const reloadRadius = () =>
  apiFetch<CommandResult>("/settings/radius/reload", { method: "POST", body: "{}" });

export const radiusStatus = () => apiFetch<CommandResult>("/settings/radius/status");

export const backupNow = () =>
  apiFetch<CommandResult>("/settings/backup", { method: "POST", body: "{}" });
